import * as React from 'react';
import styled from '@emotion/styled';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Separator from 'components/common/Separator';
import { Palette } from 'config';
import { closeIcon } from 'assets/icons';
import { IconButton } from 'components';

export default function ModalWrapper({ handleClose = () => {}, open, title, children }) {
  return (
    <Dialog maxWidth={false} open={open} onClose={handleClose}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <DialogHeaderTitle>{title}</DialogHeaderTitle>
        <IconButton.SmallSizeBigIcon
          icon={closeIcon}
          type={IconButton.btnTypes.tertiary}
          onClick={handleClose}
        />
      </DialogTitle>
      <Separator width={'100%'} marginLeft={0} />
      <MyDialogContent>{children}</MyDialogContent>
    </Dialog>
  );
}

const MyDialogContent = styled(DialogContent)`
  padding: 16px 0 0;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${() => Palette.PrimaryGray._300};
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }
`;

const DialogHeaderTitle = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #0f172a;
`;
